"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orgNrRegex = exports.phoneRegex = exports.regNrRegex = exports.emailRegex = void 0;
exports.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
exports.regNrRegex = /[A-Z]{2}\d{4,5}/;
exports.phoneRegex = /^((00|\+){1}47)?[0-9]{8}$/;
exports.orgNrRegex = /^([0-9]{4}:)?([0-9]{9})$/;
//# sourceMappingURL=validation.js.map